export default __webpack_public_path__ + "static/media/laza_xl.d2b9880c.jpg";